import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

function Footer() {
  const { role } = useAuth();
  const { t } = useTranslation('common');
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-brand-heading">
            <img src="/logo-icon.png" alt="" className="footer-brand-icon" />
            <h3>Zlux</h3>
          </div>
          <p>{t('footer.blurb')}</p>
        </div>

        <div className="footer-column">
          <h4>{t('footer.navigate')}</h4>
          <ul>
            {role === 'user' && (
              <>
                <li><Link to="/">{t('nav.dashboard')}</Link></li>
                <li><Link to="/expenses">{t('nav.expenses')}</Link></li>
                <li><Link to="/goals">{t('nav.goals')}</Link></li>
                <li><Link to="/checklist">{t('nav.checklist')}</Link></li>
              </>
            )}
            {role === 'staff' && <li><Link to="/staff">{t('footer.staffDashboard')}</Link></li>}
            {role === 'admin' && <li><Link to="/admin">{t('footer.adminDashboard')}</Link></li>}
            <li><Link to="/settings">{t('footer.accountSettings')}</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>{t('footer.whatZluxDoes')}</h4>
          <ul className="footer-feature-list">
            <li>💰 {t('footer.featureExpense')}</li>
            <li>🎯 {t('footer.featureGoal')}</li>
            <li>✅ {t('footer.featureChecklist')}</li>
            <li>🔔 {t('footer.featureAlerts')}</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>{t('footer.support')}</h4>
          <p>{t('footer.supportBlurb')}</p>
          {role === 'user' ? (
            <Link to="/support" className="footer-link-strong">{t('footer.contactSupport')}</Link>
          ) : (
            <a href="mailto:support@zlux.app" className="footer-link-strong">support@zlux.app</a>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.rights', { year })}</p>
        <p>{t('footer.madeWith')}</p>
      </div>
    </footer>
  );
}

export default Footer;
